module.exports = __webpack_public_path__ + "static/carousel-6-d7148f9ab46b9d8fb1a04c32b51e617b.jpg";